var UserInfo = /** @class */ (function () {
    function UserInfo(options) {
        this.uid = options.uid || '';
        this.uin = options.uin ? options.uin : '';
        this.loginTime = new Date().getTime();
    }
    UserInfo.prototype.getUserId = function () {
        return this.uid;
    };
    UserInfo.prototype.setUserId = function (uid) {
        this.uid = uid;
    };
    return UserInfo;
}());
export { UserInfo };
//# sourceMappingURL=UserInfo.js.map